<template>
  <div class="columns is-multiline">
    <div class="column is-one-third-desktop">
      <div class="card has-equal-height feature mini-rounded hover-brighter bs">
        <Feature icon="fab fa-envira">
          <EditSingleField
            slot="title"
            v-model="fields['head1']"
            css="has-text-white"
          ></EditSingleField>
          <EditField
            slot="description"
            v-model="fields['col1']"
            css="has-text-white"
          ></EditField>
        </Feature>
      </div>
    </div>
    <div class="column is-one-third-desktop">
      <div class="card has-equal-height feature mini-rounded hover-brighter bs">
        <Feature title="Mångsidighet" icon="fas fa-magic">
          <EditSingleField
            slot="title"
            v-model="fields['head2']"
            css="has-text-white"
          ></EditSingleField>
          <EditField
            slot="description"
            v-model="fields['col2']"
            css="has-text-white"
          ></EditField>
        </Feature>
      </div>
    </div>
    <div class="column is-one-third-desktop">
      <div class="card has-equal-height feature mini-rounded hover-brighter bs">
        <Feature icon="fas fa-award">
          <EditSingleField
            slot="title"
            v-model="fields['head3']"
            css="has-text-white"
          ></EditSingleField>
          <EditField
            slot="description"
            v-model="fields['col3']"
            css="has-text-white"
          ></EditField>
        </Feature>
      </div>
    </div>
  </div>
</template>

<script>
import Feature from "@/components/singles/Feature.vue";
import EditSingleField from "@/components/singles/EditSingleField/component.vue";
import EditField from "@/components/main/EditField.vue";

export default {
  components: { Feature, EditSingleField, EditField },
  data() {
    return {
      ready: false,
      fields: {
        head1: { value: null },
        head2: { value: null },
        head3: { value: null },
        col1: { value: null },
        col2: { value: null },
        col3: { value: null }
      }
    };
  },
  async created() {
    this.fields = await this.$helpers.GetPageFields(this.fields);
    this.ready = true;
  }
};
</script>
